import { jsx as c, jsxs as h, Fragment as Y } from "react/jsx-runtime";
import { u as l } from "./index-6a632112.mjs";
import { s as a, b as $, r as z, d as v, a as w, e as B, l as Z } from "./themes-5f0b3c3d.mjs";
import T, { createContext as oo, useState as F, useContext as U, useRef as K, useEffect as V } from "react";
import { S as q } from "./caretUp-e6db3a6f.mjs";
import { l as _ } from "./lineHeights-72d3110c.mjs";
import { useAccessibilityProps as E } from "./accessibility.js";
import { a as no, b as to } from "./superScript-393c70dc.mjs";
import { DropdownMenu as N } from "./dropdownMenu.js";
import { m as ro, A as eo } from "./index-c8707610.mjs";
import "./types-b577bf77.mjs";
import "./textInput.js";
import "./uniqueId-321287e8.mjs";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./label-3b996c7d.mjs";
import "./tooltip.js";
import "./useWindowDimensions.js";
import "./zIndices-d07533f3.mjs";
import "./getElementPosition-5026bb28.mjs";
import "./popupTip.js";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./iconButton.js";
import "./button.js";
import "./checkmarkFilled-c2b01ef1.mjs";
import "./informationFilled-05d57719.mjs";
import "./helperText-698f3ed9.mjs";
import "./warningFilled-691cfde1.mjs";
import "./index-39f84169.mjs";
import "./radio.js";
import "./checkbox.js";
import "./checkmark-84b5274e.mjs";
import "./subtract-848336fd.mjs";
import "./menu.js";
import "./moreVertical-dc2e97a2.mjs";
import "./tslib.es6-59e1c9d8.mjs";
const P = oo({
  openItemId: null,
  handleItemClick: () => {
  },
  isParentBoxVariation: !1
}), G = ({
  children: o,
  boxVariation: n
}) => {
  const [t, i] = F(null), e = (m) => {
    i(
      (r) => r === m ? null : m
    );
  }, u = T.useMemo(
    () => ({
      openItemId: t,
      handleItemClick: e,
      isParentBoxVariation: n
    }),
    [t, n]
  );
  return /* @__PURE__ */ c(P.Provider, { value: u, children: o });
}, io = l.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ boxVariation: o }) => o ? a["3x"] : "0px"};
`, co = "ACCORDION_DATA_TEST_ID", ao = ({
  children: o = [],
  boxVariation: n = !1,
  singleSelect: t,
  className: i,
  containerId: e,
  dataTestId: u = co
}) => {
  const m = Array.isArray(o) ? o : [o];
  return /* @__PURE__ */ c(G, { boxVariation: n, children: /* @__PURE__ */ c(
    io,
    {
      id: e,
      dataTestId: u,
      className: i,
      singleSelect: t,
      boxVariation: n,
      children: m.map((r, A) => r ? T.cloneElement(r, {
        singleSelect: t,
        id: r.props.id,
        title: r.props.title,
        subTitle: r.props.subTitle,
        icon: r.props.icon,
        boxVariation: r.props.boxVariation,
        className: r.props.className,
        dataTestId: r.props.dataTestId,
        children: r.props.children,
        disabled: r.props.disabled,
        key: A
      }) : null)
    }
  ) });
}, lo = l.div`
  display: flex;
  flex-direction: column;
  border-bottom: ${$["1x"]} solid
    ${({ theme: o }) => o.components.accordion.borderBottom};
  background: ${({ disabled: o, boxVariation: n, theme: t }) => o && n ? t.components.accordion.boxDisabledBackgroundColor : t.components.accordion.backgroundColor};
  &:hover {
    border-bottom: ${$["1x"]} solid
      ${({ disabled: o, theme: n }) => o ? n.components.accordion.borderBottom : n.components.accordion.hoverBorderBottom};
  }
  &:focus-visible {
    outline: none;
    border-bottom: ${$["2x"]} solid
      ${({ theme: o }) => o.components.accordion.hoverBorderBottom};
  }
  ${({ boxVariation: o, disabled: n, theme: t }) => {
  if (o)
    return `
        border-radius: ${z["2x"]};
        outline: ${$["1x"]} solid ${t.components.accordion.boxBorderColor};
        border-bottom:unset;
        &:hover {
          outline: ${$["1x"]} solid
          ${n ? t.components.accordion.boxBorderColor : t.components.accordion.boxHoverOutlineColor};
          border-bottom:unset;
        }
        &:focus-visible {
          outline:  ${$["2x"]} solid ${t.components.accordion.boxHoverOutlineColor};
          border-bottom:unset;
        }
      `;
}}
`, so = l.button`
  display: flex;
  padding: ${a["4x"]} ${a["8x"]};
  flex-direction: row;
  align-items: ${(o) => o.$isDropDownMenu && "center" || "flex-start"};
  gap: ${a["4x"]};
  align-self: stretch;
  cursor: ${({ disabled: o }) => o ? "not-allowed" : "pointer"};
  background: ${({ disabled: o, boxVariation: n, theme: t }) => o && n ? t.components.accordion.boxDisabledBackgroundColor : t.components.accordion.backgroundColor};
  border: none;
`, po = l.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${a["1x"]};
  flex: 1 0 0;
`, mo = l.div`
  color: ${({ disabled: o, theme: n }) => o ? n.components.accordion.textDisabledColor : n.components.accordion.titleColor};
  font-family: ${v.body};
  font-size: ${w.small};
  font-style: normal;
  font-weight: ${B.medium.M.fontWeight};
  line-height: ${_.small};
  text-align: left;
`, $o = l.div`
  color: ${({ disabled: o, theme: n }) => o ? n.components.accordion.textDisabledColor : n.components.accordion.subTitleColor};
  font-family: ${v.body};
  font-size: ${w.xsmall};
  font-style: normal;
  font-weight: ${B.regular.S.fontWeight};
  line-height: ${_.small};
  text-align: left;
`, fo = l.div`
  display: flex;
  min-height: ${a["6x"]};
  justify-content: center;
  align-items: center;
  svg,
  img {
    width: ${a["5x"]};
    height: ${a["5x"]};
    color: ${({ disabled: o, theme: n }) => o ? n.components.accordion.iconDisabledColor : n.components.accordion.iconColor};
  }
`, uo = l.span`
  display: flex;
  width: ${a["6x"]};
  height: ${a["6x"]};
  justify-content: center;
  align-items: center;
  ${({ $isAccordionOpen: o }) => `transform: rotate(${o ? "0deg" : "-180deg"});`}
  transition: transform ${({ $isAnimate: o }) => o ? "0.3s" : "0s"} ease-in-out;
  svg,
  img {
    color: ${({ disabled: o, theme: n }) => o ? n.components.accordion.iconDisabledColor : n.components.accordion.toggleIconColor};
  }
`, xo = l.div`
  ${({ $isAnimate: o, accordionOpen: n, $wrapperHeight: t }) => o ? `
        height: ${n ? `${t}px` : "0px"};
        overflow: hidden;
        transition: all 0.3s ease-in-out;
      ` : `
        display: ${n ? "flex" : "none"};
      `}
  padding: 0px ${a["8x"]};
`, go = l.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: ${(o) => o.$isDropDownMenu && "center" || "flex-start"};
  gap: 8px;
`, bo = "ACCORDION_ITEM_DATA_TEST_ID", ho = ({
  children: o,
  title: n,
  subTitle: t,
  singleSelect: i,
  id: e,
  icon: u,
  boxVariation: m,
  disabled: r,
  className: A,
  dataTestId: O = bo,
  isIconOnClickEnabled: j = !0,
  isDropDownMenu: C = !1,
  DropDownComponent: x,
  isAnimate: D = !0,
  accessibilityOptions: W = {}
}) => {
  const { openItemId: S, handleItemClick: H } = U(P), s = S === e, [d, g] = F(!1), y = K(null), k = E("button", {
    ...W,
    ariaExpanded: d,
    ariaControls: `accordion-content-${e}`,
    ariaDisabled: r || !1,
    tabIndex: -1
  }), L = E("region", {
    ariaLabelledBy: `accordion-header-${e}`,
    ariaHidden: i ? !s : !d
  });
  V(() => {
    y.current && d && D && (y.current.style.maxHeight = `${y.current.scrollHeight}px`);
  }, [d, D]);
  const b = () => {
    d ? M() : I(), i && H(e);
  }, I = () => {
    g(!0);
  }, M = T.useCallback(() => {
    g(!1);
  }, []);
  return /* @__PURE__ */ h(
    lo,
    {
      tabIndex: r ? -1 : 0,
      onKeyDown: (f) => {
        (f.key === "Enter" || f.key === " ") && (f.preventDefault(), b());
      },
      accordionOpen: d,
      disabled: r,
      boxVariation: m,
      children: [
        /* @__PURE__ */ h(
          so,
          {
            id: `accordion-header-${e}`,
            "data-testid": O,
            boxVariation: m,
            disabled: r,
            singleSelect: i,
            className: A,
            onClick: !r && !T.isValidElement(x) ? b : void 0,
            accordionOpen: d,
            $isDropDownMenu: C,
            ...k,
            children: [
              u && /* @__PURE__ */ c(
                fo,
                {
                  "data-component": "accordion-icon-wrapper",
                  disabled: r,
                  onClick: (f) => {
                    j && b(), f.stopPropagation();
                  },
                  children: u
                }
              ),
              /* @__PURE__ */ h(
                po,
                {
                  onClick: (f) => {
                    b();
                  },
                  children: [
                    /* @__PURE__ */ c(
                      mo,
                      {
                        disabled: r,
                        "data-component": "accordion-title-wrapper",
                        children: n
                      }
                    ),
                    t && /* @__PURE__ */ c($o, { disabled: r, children: t })
                  ]
                }
              ),
              /* @__PURE__ */ h(go, { $isDropDownMenu: C, children: [
                /* @__PURE__ */ c(
                  uo,
                  {
                    onClick: (f) => {
                      b();
                    },
                    "data-component": "accordion-dropdown-wrapper",
                    disabled: r,
                    role: "button",
                    $isAccordionOpen: i ? s : d,
                    $isAnimate: D,
                    children: /* @__PURE__ */ c(q, { "aria-hidden": !1 })
                  }
                ),
                C && x || /* @__PURE__ */ c(Y, {})
              ] })
            ]
          }
        ),
        /* @__PURE__ */ c(
          xo,
          {
            accordionOpen: i ? s : d,
            isSingleSelectOpen: s,
            "aria-labelledby": `accordion-header-${e}`,
            id: `accordion-content-${e}`,
            "aria-hidden": i ? !s : !d,
            ref: y,
            $wrapperHeight: y?.current?.scrollHeight,
            $isAnimate: D,
            role: "region",
            ...L,
            children: o
          }
        )
      ]
    }
  );
}, Co = l.div`
  ${no()}
  ${to()}
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ $boxVariation: o }) => o ? a["3x"] : "0px"};
`, yo = "ACCORDION_DATA_TEST_ID", Cn = ({
  children: o,
  boxVariation: n = !1,
  className: t,
  containerId: i,
  dataTestId: e = yo
}) => /* @__PURE__ */ c(G, { boxVariation: n, children: /* @__PURE__ */ c(
  Co,
  {
    id: i,
    "data-testid": e,
    className: t,
    $boxVariation: n,
    children: o
  }
) }), Do = l.div`
  display: flex;
  flex-direction: column;
  border-bottom: ${$["1x"]} solid
    ${({ theme: o }) => o.components.accordion.borderBottom};
  background: ${({ disabled: o, $boxVariation: n, theme: t }) => o && n ? t.components.accordion.boxDisabledBackgroundColor : t.components.accordion.backgroundColor};

  &:hover {
    border-bottom: ${$["1x"]} solid
      ${({ disabled: o, theme: n, $inactive: t }) => o || t ? n.components.accordion.borderBottom : n.components.accordion.hoverBorderBottom};
  }
  &:focus-visible {
    outline: none;
    border-bottom: ${$["2x"]} solid
      ${({ theme: o, $inactive: n }) => n ? "tranparent" : o.components.accordion.hoverBorderBottom};
  }

  ${({ $boxVariation: o, disabled: n, theme: t, $inactive: i }) => {
  if (o)
    return `
        border-radius: ${z["2x"]};
        outline: ${$["1x"]} solid ${t.components.accordion.boxBorderColor};
        border-bottom:unset;

        &:hover {
          outline: ${$["1x"]} solid
          ${n || i ? t.components.accordion.boxBorderColor : t.components.accordion.boxHoverOutlineColor};
          border-bottom:unset;
        }
        &:focus-visible {
          outline:  ${$["2x"]} solid ${i ? t.components.accordion.boxBorderColor : t.components.accordion.boxHoverOutlineColor};
          border-bottom:unset;

        }
      `;
}}
`, Ao = l.button`
  display: flex;
  padding: ${a["4x"]} ${a["8x"]};
  flex-direction: row;
  align-items: ${(o) => o.$isDropDownMenu && "center" || "flex-start"};
  gap: ${a["4x"]};
  align-self: stretch;
  cursor: ${({ disabled: o, $inactive: n }) => o || n ? "not-allowed" : "pointer"};

  background: ${({ disabled: o, $boxVariation: n, theme: t }) => o && n ? t.components.accordion.boxDisabledBackgroundColor : t.components.accordion.backgroundColor};
  border: none;
`, Io = l.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${a["1x"]};
  flex: 1 0 0;
`, To = l.div`
  color: ${({ $disabled: o, theme: n }) => o ? n.components.accordion.textDisabledColor : n.components.accordion.titleColor};

  font-family: ${v.body};
  font-size: ${w.small};
  font-style: normal;
  font-weight: ${B.medium.M.fontWeight};
  line-height: ${_.small};
  text-align: left;
`, vo = l.div`
  color: ${({ disabled: o, theme: n }) => o ? n.components.accordion.textDisabledColor : n.components.accordion.subTitleColor};

  font-family: ${v.body};
  font-size: ${w.xsmall};
  font-style: normal;
  font-weight: ${B.regular.S.fontWeight};
  line-height: ${_.small};
  text-align: left;
`, wo = l.div`
  display: flex;
  min-height: ${a["6x"]};
  justify-content: center;
  align-items: center;

  svg,
  img {
    width: ${a["5x"]};
    height: ${a["5x"]};
    color: ${({ disabled: o, theme: n }) => o ? n.components.accordion.iconDisabledColor : n.components.accordion.iconColor};
  }
`, _o = l.span`
  display: flex;
  width: ${a["6x"]};
  height: ${a["6x"]};
  justify-content: center;
  align-items: center;
  ${({ $isAccordionOpen: o }) => `transform: rotate(${o ? "0deg" : "-180deg"});`}
  transition: transform ${({ $isAnimate: o }) => o ? "0.3s" : "0s"} ease-in-out;

  svg,
  img {
    color: ${({ disabled: o, theme: n }) => o ? n.components.accordion.iconDisabledColor : n.components.accordion.toggleIconColor};
  }
`, ko = l(ro.div)`
  padding: 0px ${a["8x"]};
`, Eo = l.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: ${(o) => o.$isDropDownMenu && "center" || "flex-start"};
  gap: 8px;
`, Bo = "ACCORDION_ITEM_DATA_TEST_ID", yn = ({
  children: o,
  title: n,
  subTitle: t,
  singleSelect: i,
  id: e,
  icon: u,
  boxVariation: m,
  disabled: r,
  className: A,
  dataTestId: O = Bo,
  isIconOnClickEnabled: j = !0,
  isDropDownMenu: C = !1,
  dropDownProps: x,
  isAnimate: D = !0,
  accessibilityOptions: W = {},
  openAccordian: S,
  setOpenAccordian: H,
  openAccordion: s = S,
  setOpenAccordion: d = H,
  inactive: g = !1
}) => {
  const { openItemId: y, handleItemClick: k, isParentBoxVariation: L } = U(P);
  m = L || m;
  const b = K(null), I = y === e, M = E("button", {
    ...W,
    ariaExpanded: s,
    ariaControls: `accordion-content-${e}`,
    ariaDisabled: r || !1,
    tabIndex: -1
  }), R = E("region", {
    ariaLabelledBy: `accordion-header-${e}`,
    ariaHidden: i ? !I : !s
  });
  V(() => {
    k(e);
  }, [s]);
  const f = (p) => {
    s ? Q(p) : J(p), i && k(e);
  }, J = (p) => {
    !g && d && d(p, e, !0);
  }, Q = T.useCallback((p) => {
    !g && d && d(p, e, !1);
  }, []), X = (p) => {
    (p.key === "Enter" || p.key === " ") && p.target === b.current && (p.preventDefault(), f(p));
  };
  return /* @__PURE__ */ h(
    Do,
    {
      $inactive: g,
      id: `accordion-header-${e}`,
      tabIndex: r ? -1 : 0,
      onKeyDown: X,
      disabled: r,
      $boxVariation: m,
      ref: b,
      children: [
        /* @__PURE__ */ h(
          Ao,
          {
            $inactive: g,
            id: `accordion-header-${e}`,
            "data-testid": O,
            $boxVariation: m,
            disabled: r,
            singleSelect: i,
            className: A,
            onClick: r ? void 0 : f,
            $isDropDownMenu: C,
            ...M,
            children: [
              u && /* @__PURE__ */ c(
                wo,
                {
                  "data-component": "accordion-icon-wrapper",
                  disabled: r,
                  children: u
                }
              ),
              /* @__PURE__ */ h(Io, { id: `accordion-header-content-${e}`, children: [
                /* @__PURE__ */ c(
                  To,
                  {
                    $disabled: r,
                    "data-component": "accordion-title-wrapper",
                    children: n
                  }
                ),
                t && /* @__PURE__ */ c(vo, { disabled: r, children: t })
              ] }),
              /* @__PURE__ */ h(Eo, { $isDropDownMenu: C, children: [
                !g && /* @__PURE__ */ c(
                  _o,
                  {
                    "data-component": "accordion-dropdown-wrapper",
                    disabled: r,
                    role: "button",
                    $isAccordionOpen: i ? I : s,
                    $isAnimate: D,
                    children: /* @__PURE__ */ c(q, { "aria-hidden": !1 })
                  }
                ),
                C && /* @__PURE__ */ c(
                  N,
                  {
                    closeOnSelect: x?.closeOnSelect,
                    menuDirection: x?.menuDirection,
                    onChange: x?.onChange,
                    children: x?.items && x?.items.map((p, Ho) => /* @__PURE__ */ c(N.Item, { label: p.label, value: p.value }))
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ c(eo, { children: s && /* @__PURE__ */ c(
          ko,
          {
            initial: "collapsed",
            animate: s ? "open" : "collapsed",
            exit: "collapsed",
            variants: {
              open: {
                height: "auto",
                transitionEnd: {
                  overflow: "unset"
                }
              },
              collapsed: {
                height: 0,
                overflow: "hidden"
              }
            },
            transition: { duration: 0.3, ease: "easeInOut" },
            "aria-labelledby": `accordion-header-${e}`,
            id: `accordion-content-${e}`,
            "aria-hidden": i ? !s || !I : !s,
            role: "region",
            $isOpen: s,
            ...R,
            children: o
          },
          "content"
        ) })
      ]
    }
  );
}, Oo = l.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  padding-bottom: ${a["6x"]};
`, Wo = l.div`
  width: 100%;
  color: ${(o) => o.theme.components.accordion.subTitleColor};
  font-family: ${v.body};
  font-size: ${w.small};
  letter-spacing: ${Z[0]};
  line-height: ${_.medium};
  text-align: left;
`, So = "ACCORDION_PANEL_DATA_TEST_ID", Dn = ({
  boxVariation: o,
  content: n,
  className: t,
  dataTestId: i = So
}) => /* @__PURE__ */ c(
  Oo,
  {
    className: t,
    "data-testid": i,
    boxVariation: o,
    children: /* @__PURE__ */ c(Wo, { children: n })
  }
), An = ao, In = ho;
export {
  Cn as Accordion,
  yn as AccordionItem,
  In as AccordionItemOld,
  An as AccordionOld,
  Dn as AccordionPanel
};
